import React from 'react';
import { amcTitleCase } from '../../utils';
import ReadMore from '../common/readmore';
import amcStyles from '../../styles/amcs.scss';

interface AboutAMCProps {
  customContent: string;
  issuingAuthority: string;
}

const AboutAmc: React.FC<AboutAMCProps> = ({
  customContent,
  issuingAuthority,
}) => {
  const aboutText = customContent.slice(
    customContent.indexOf('\n'),
    customContent.indexOf('##', customContent.indexOf('\n'))
  );

  return aboutText && aboutText.trim() !== '' ? (
    <div>
      <h2
        className={`${amcStyles['plan-title']} lil-pt-4 lil-pb-6 sm:lil-pt-0`}
      >
        About {amcTitleCase(issuingAuthority)}
      </h2>
      <ReadMore text={aboutText} maxLength={360} />
    </div>
  ) : null;
};

export default AboutAmc;



// WEBPACK FOOTER //
// ./components/amcNew/AboutAmc.tsx